import { BiLingualValue } from 'types/common'

/**
 * Type-guard for BiLingualValue<string> to distinguish it from a simple string
 * @param {string | BiLingualValue<string>} text
 * @returns {text is BiLingualValue<string>}
 */
export const isBilingualText = (text: string | BiLingualValue<string>): text is BiLingualValue<string> => {
  return typeof text !== 'string'
}
